import styled from "@emotion/styled";
import { Table, TableCell, TableHead, TableRow } from "@mui/material";

interface StyledTableCellProps {
	fixedWidth?: string;
	minWidth?: string;
	isLastIndex?: boolean;
	maxWidth?: string;
}

export const StyledTableWrapper = styled(Table)(({ theme }) => ({
	border: theme.project.borders.presets.outline,
	borderWidth: "1px"
}));

const shouldForwardStyledTableCellProp = (prop: string) =>
	!["fixedWidth", "minWidth", "isLastIndex", "maxWidth"].includes(prop);

export const StyledTableCell = styled(TableCell, {
	shouldForwardProp: shouldForwardStyledTableCellProp
})<StyledTableCellProps>(({ fixedWidth, minWidth, isLastIndex, maxWidth }) => ({
	padding: `14px ${isLastIndex ? 16 : 8}px 14px 16px`,
	width: fixedWidth ?? "auto",
	minWidth: minWidth ?? fixedWidth ?? "80px",
	maxWidth: maxWidth ?? "none",
	wordBreak: "break-word"
}));

export const HoveredStyledTableRow = styled(TableRow)(({ theme }) => ({
	cursor: "pointer",
	"&:hover": {
		backgroundColor: theme.project.colors.backgroundColors["card:hover"]
	}
}));

export const TableSkeletonRow = styled.div({
	display: "grid",
	gap: 24,
	gridTemplateColumns: "1fr 2fr 2fr 2fr 2fr 1fr",
	div: {
		display: "flex",
		width: "100%"
	},
	"& > div:nth-of-type(1)": {
		flexDirection: "column",
		gap: 8
	}
});

export const CustomTableHeader = styled(TableHead)(({ theme }) => ({
	backgroundColor: theme.project.colors.backgroundColors.tertiary,
	"& .MuiTableCell-head": {
		padding: "6px 16px"
	}
}));
